export default "__VITE_ASSET__mrFvA_2$__";